module.exports = __webpack_public_path__ + "static/media/Integration-image-reconciled-payments.8a12d5bc.jpg";